// @flow

import Formatic from 'formatic';

import commonFormaticPlugin from 'app/common/formaticPlugin';
import {
  developerPlugin,
  fieldMessagesPlugin,
  needsPlugin,
} from 'app/developer-v3/formatic-plugins';

export default Formatic.createConfig(
  commonFormaticPlugin,
  Formatic.plugins.meta,
  fieldMessagesPlugin,
  needsPlugin,
  developerPlugin
);
